export default __webpack_public_path__ + "static/media/00.0193b698.jpg";